var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGooglePodcasts = function SvgGooglePodcasts(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88 25.932a3.88 3.88 0 0 1 3.88 3.88v4.377a3.88 3.88 0 1 1-7.76 0v-4.376a3.88 3.88 0 0 1 3.88-3.88Z",
    fill: "#0066D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.12 25.932a3.88 3.88 0 0 1 3.88 3.88v4.377a3.88 3.88 0 1 1-7.76 0v-4.376a3.88 3.88 0 0 1 3.88-3.88Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.94 12.804a3.88 3.88 0 0 1 3.88 3.88v14.314a3.88 3.88 0 1 1-7.76 0V16.684a3.88 3.88 0 0 1 3.88-3.88Zm0 26.258a3.88 3.88 0 0 1 3.88 3.88v4.376a3.88 3.88 0 1 1-7.76 0v-4.376a3.88 3.88 0 0 1 3.88-3.88Z",
    fill: "#EA4335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.06 12.802a3.88 3.88 0 0 1 3.88 3.88v4.377a3.88 3.88 0 1 1-7.76 0v-4.377a3.88 3.88 0 0 1 3.88-3.88Zm0 16.32a3.88 3.88 0 0 1 3.88 3.881v14.314a3.88 3.88 0 1 1-7.76 0V33.003a3.88 3.88 0 0 1 3.88-3.88Z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 0a3.88 3.88 0 0 1 3.88 3.88v4.377a3.88 3.88 0 1 1-7.76 0V3.88A3.88 3.88 0 0 1 32 0Zm0 16.45a3.88 3.88 0 0 1 3.88 3.88v23.34a3.88 3.88 0 0 1-7.76 0V20.33A3.88 3.88 0 0 1 32 16.45Zm0 35.413a3.88 3.88 0 0 1 3.88 3.88v4.377a3.88 3.88 0 1 1-7.76 0v-4.377a3.88 3.88 0 0 1 3.88-3.88Z",
    fill: "#FAB908"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGooglePodcasts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "8b37b6c3f768411854e490d6a3ade14f.svg";